module.exports = __webpack_public_path__ + "static/media/spinner.3f024253.gif";